// web/src/contact/api.ts
//
// Typed wrapper for POST /api/v1/contact. Used by ContactForm. The
// request body uses snake_case (`turnstile_token`) to match the
// backend's Pydantic ContactRequest field names; the TS-side argument
// uses camelCase (turnstileToken) for idiomatic frontend usage.
import { apiFetch } from "@/api/client";

export type ContactTopic = "privacy" | "support" | "billing" | "other";

export type ContactPayload = {
  name?: string;
  email: string;
  subject?: string;
  topic: ContactTopic;
  message: string;
  turnstileToken?: string;
};

export async function submitContact(payload: ContactPayload): Promise<void> {
  // Build a stable-shape object so the JSON.stringify output is
  // deterministic (tests assert the literal body string). Field order:
  // name, email, subject, topic, message, turnstile_token.
  const body: Record<string, unknown> = {};
  if (payload.name !== undefined) body.name = payload.name;
  body.email = payload.email;
  if (payload.subject !== undefined) body.subject = payload.subject;
  body.topic = payload.topic;
  body.message = payload.message;
  if (payload.turnstileToken !== undefined) body.turnstile_token = payload.turnstileToken;

  await apiFetch<void>("/api/v1/contact", {
    method: "POST",
    body: JSON.stringify(body),
  });
}
